import { ExclamationCircleIcon } from "@heroicons/react/solid";
import { ReactNode } from "react";
import { useLocalizedStrings } from "../Localization";

export function HeroNumber(props: {
    title: ReactNode,
    value: string,
    suffix?: string,
    prefix?: string,
    valueToCompare?: string
}) {
    const L = useLocalizedStrings();
    const potentiallyStale = !!props.valueToCompare && props.valueToCompare !== props.value;

    return <div>
        <div className="my-4 mr-4 float-left text-center bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-4 sm:p-6">
                <dl>
                    <dt className="text-sm font-medium text-gray-500 truncate">
                        {props.title}
                    </dt>
                    <dd className="mt-1 text-3xl font-semibold text-gray-900">
                        {props.prefix}{parseFloat(props.value).toFixed(2)}{props.suffix}{
                            potentiallyStale && <sup><ExclamationCircleIcon className="h-6 w-6 text-yellow-400" /></sup>
                        }
                    </dd>
                    {potentiallyStale &&
                        <dd className="-mt-3 text-gray-300">
                            ({L.online}:&nbsp;{parseFloat(props.valueToCompare!).toFixed(2)})
                        </dd>
                    }
                </dl>
            </div>
        </div>
    </div>
}
